import { Anchor, Box, Breadcrumbs, Container, Divider, Group, LoadingOverlay, Space, Stack } from '@mantine/core';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { DndProvider } from 'react-dnd-latest';
import { HTML5Backend } from 'react-dnd-html5-backend-latest';
import { QuestionnaireTemplateContext } from '../../../Service/Context/QuestionnaireTemplateContext';
import { RichInput } from '../../../Organismns/tiptap/TiptapEditorInput';
import { TiptapS } from '../../../Service/TiptapS';
import DocumentBubbleMenu from '../../../Organismns/tiptap/toolbars/BubbleMenu';
import SkeletonItems, { QuestionBundleSkeleton } from '../../../Atoms/SkeletonItems';
import LinkText from '../../../Atoms/LinkText';
import QuestionnaireAlert from '../../../Atoms/QuestionnaireAlert';
import QuestionnaireTemplateActions from './QuestionnaireTemplateActions';
import QuestionBundle from './QuestionBundle';

const QuestionnaireTemplateEditor = () => {
  const { loading, insertingBundle, template, patchTemplate, bundleHandlers, questionHandlers } =
    useContext(QuestionnaireTemplateContext);
  const navigate = useNavigate();
  const { insertBundle } = bundleHandlers;
  const { name, headRow, endRow, questionBundles } = template ?? {};
  const emptyBundles = questionBundles?.length === 0;

  return (
    <Container p={0} pos="relative">
      <LoadingOverlay visible={loading} overlayBlur={2} loaderProps={{ size: 'xl' }} />
      <Group position="apart" sx={{ alignItems: 'center' }}>
        <Breadcrumbs>
          <Anchor onClick={() => navigate('/settings/questionnaires')}>Fragebogen-Vorlagen</Anchor>
          <Anchor sx={{ pointerEvents: 'none' }}>
            <b>{loading ? 'Laden ...' : name}</b>
          </Anchor>
        </Breadcrumbs>
        <QuestionnaireTemplateActions />
      </Group>
      <Divider my="xs" />
      <QuestionnaireAlert />
      {headRow !== undefined && (
        <RichInput
          label="Kopfzeile"
          value={headRow}
          patchField={(htmlString) => patchTemplate({ headRow: htmlString })}
          menu={<DocumentBubbleMenu />}
          styles={TiptapS.TextInputStyles}
        />
      )}
      {loading && <SkeletonItems height={50} />}
      <Box pos="relative">
        <LoadingOverlay visible={insertingBundle} overlayBlur={2} loaderProps={{ size: 'xl' }} />
        {!loading && emptyBundles && (
          <>
            <QuestionBundleSkeleton />
            <LinkText mt={5} mb="xl" ml="sm" onClick={() => insertBundle()}>
              + Abschnitt hinzufügen
            </LinkText>
          </>
        )}
        {!emptyBundles && (
          <DndProvider backend={HTML5Backend}>
            {questionBundles && (
              <Stack my="xl">
                {questionBundles.map((qb) => (
                  <QuestionBundle
                    key={qb.id}
                    bundle={qb}
                    bundleHandlers={bundleHandlers}
                    questionHandlers={questionHandlers}
                  />
                ))}
              </Stack>
            )}
          </DndProvider>
        )}
      </Box>
      {endRow !== undefined && (
        <RichInput
          label="Fußzeile"
          value={endRow}
          patchField={(htmlString) => patchTemplate({ endRow: htmlString })}
          menu={<DocumentBubbleMenu />}
          styles={{ minHeight: 150 }}
        />
      )}
      <Space h="xl" />
    </Container>
  );
};

export default QuestionnaireTemplateEditor;
